// Imports
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

import store from '../store'

import firebase from '@/api/config/FirebaseConfig'

// FOR DEVELOPMENT
import ComponentView from '@/views/dev/ComponentView'
import { _ } from 'core-js'

// Dynamic imports
const AccountView = () => import('@/views/account/AccountView')
const AdsPublicView = () => import('../views/ads/AdsPublicView')
const AdsPublicViewDiscover = () => import('../views/ads/AdsPublicViewDiscover')
const AuthCallbackView = () => import('../views/auth/AuthCallbackView')
const BoardsDetailsView = () => import('@/views/boards/BoardsDetailsView')
const BoardsPublicView = () => import('../views/boards/BoardsPublicView')
const BoardsView = () => import('@/views/boards/BoardsView')
const BrandView = () => import('@/views/brands/BrandView')
const BriefPublicViewV2 = () => import('../views/briefs/BriefPublicViewV2.vue')
const BriefsView = () => import('../views/briefs/BriefsView.vue')
const ChromeExtensionAuthView = () => import('../views/auth/ChromeExtensionAuthView')
const DashboardView = () => import('@/views/dashboard/DashboardView')
const DataApiView = () => import('@/views/api/DataApiView')
const DiscoveryAICategoryView = () => import('../views/discover/DiscoveryAICategoryView')
const DiscoveryBrandView = () => import('@/views/brands/DiscoveryBrandView')
const DiscoveryExpertPublicView = () => import('@/views/discover/DiscoveryExpertPublicView.vue')
const DiscoveryExpertView = () => import('@/views/discover/DiscoveryExpertView.vue')
const DiscoveryView = () => import('../views/discover/DiscoveryView')
const EditBriefView = () => import('../views/briefs/EditBriefView')
const ExpertRedirectView = () => import('../views/discover/ExpertRedirectView.vue')
const ForgotPasswordView = () => import('@/views/auth/ForgotPasswordView')
const ResetPasswordView = () => import('@/views/auth/ResetPasswordView')
const LensView = () => import('@/views/lens/LensView')
const LensReportView = () => import('@/views/lens/LensReportView')
const LensReportPublicView = () => import('@/views/lens/LensReportPublicView')
const LensDashboardView = () => import('@/views/lens/LensDashboardView')
const LensTest = () => import('@/views/lens/LensTest')
const LibraryView = () => import('@/views/library/LibraryView')
const LoginEmailSentView = () => import('../views/auth/LoginEmailSentView')
const LoginView = () => import('@/views/auth/LoginView')
const PaymentViewV2 = () => import('@/views/account/PaymentViewV2')
const PerksView = () => import('@/views/account/PerksView')
const SignUpView = () => import('@/views/auth/SignUpView')
const VerifyEmailView = () => import('@/views/auth/VerifyEmailView')
const CompleteVerificationView = () => import('@/views/auth/CompleteVerificationView')
const SpyderBrandsView = () => import('../views/spyder/SpyderBrandsView.vue')
const SpyderView = () => import('@/views/spyder/SpyderView')
const ThankYouRedirectView = () => import('@/views/account/ThankYouRedirectView')
const TokenLoginView = () => import('../views/auth/TokenLoginView')
const SuccessPurchaseView = () => import('../views/account/SuccessPurchaseView.vue')
const UserOnboardView = () => import('../views/auth/UserOnboardView.vue')
const ConnectFacebookLensView = () => import('../views/lens/ConnectFacebookLensView.vue')
const FacebookAuthSuccessView = () => import('../views/lens/FacebookAuthSuccessView.vue')
const FacebookDeleteDataView = () => import('../views/lens/FacebookDeleteDataView.vue')
// Install Router
Vue.use(VueRouter)

// Install Meta
Vue.use(Meta)

// Main Routes
const routes = [
  {
    path: '/components',
    name: 'ComponentView',
    component: ComponentView
  },
  {
    path: '/api-overview',
    name: 'ApiView',
    component: DataApiView,
    meta: { requiresAuth: true, theme: 'black', product: 'api', betaLocked: true }
  },
  {
    path: '/api-logs',
    name: 'ApiLogsView',
    component: DataApiView,
    meta: { requiresAuth: true, theme: 'black', product: 'api', betaLocked: true }
  },
  {
    path: '/lens',
    name: 'LensView',
    component: LensView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens' }
  },
  {
    path: '/connect-facebook-lens',
    name: 'ConnectFacebookLensView',
    component: ConnectFacebookLensView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens' }
  },
  {
    path: '/connect-facebook-lens/delete-data',
    name: 'FacebookDeleteDataView',
    component: FacebookDeleteDataView,
    meta: { requiresAuth: false, theme: 'black', hideSidebar: true }
  },
  {
    path: '/connect-facebook-lens/success',
    name: 'FacebookAuthSuccessView',
    component: FacebookAuthSuccessView,
    meta: { requiresAuth: true, theme: 'blue', product: 'lens', hideSidebar: true }
  },
  {
    path: '/lens/:lensId',
    name: 'LensDashboardView',
    component: LensDashboardView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens', tab: 'dashboard' }
    // children: [
    //   {
    //     path: '',
    //     name: 'LensDashboard',
    //     meta: { requiresAuth: true, tab: 'dashboard', theme: 'black', product: 'lens'  }
    //   },
    //   {
    //     path: 'creative-tests',
    //     name: 'LensCreativeTests',
    //     meta: { requiresAuth: true, tab: 'creative-tests', theme: 'black', product: 'lens' }
    //   },
    //   {
    //     path: 'reports',
    //     name: 'LensReports',
    //     meta: { requiresAuth: true, tab: 'reports', theme: 'black', product: 'lens' }
    //   },
    //   {
    //     path: 'inspiration',
    //     name: 'LensInspiration',
    //     meta: { requiresAuth: true, tab: 'inspiration', theme: 'black', product: 'lens' }
    //   }
    // ]
  },
  {
    path: '/lens/:lensId/reports',
    name: 'LensReports',
    component: LensDashboardView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens', tab: 'reports' }
  },
  {
    path: '/lens/:lensId/creative-tests',
    name: 'LensCreativeTests',
    component: LensDashboardView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens', tab: 'creative-tests' }
  },
  {
    path: '/lens/:lensId/inspiration',
    name: 'LensInspiration',
    component: LensDashboardView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens', tab: 'inspiration' }
  },
  {
    path: '/lens/:lensId/report/:reportId',
    name: 'LensReport',
    component: LensReportView,
    meta: { requiresAuth: true, theme: 'black', product: 'lens' }
  },
  {
    path: '/share/report/:reportId',
    name: 'LensReportPublicView',
    component: LensReportPublicView
  },
  {
    path: '/lens-test',
    name: 'LensTest',
    component: LensTest,
    meta: { requiresAuth: true, theme: 'blue', product: 'lens' }
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView,
    meta: { hideSidebar: true }
  },
  {
    path: '/sign-up',
    name: 'SignUpView',
    component: SignUpView,
    meta: { hideSidebar: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPasswordView',
    component: ForgotPasswordView
  },
  {
    path: '/reset-password/:oobCode',
    name: 'ResetPasswordView',
    component: ResetPasswordView
  },
  {
    path: '/verify-email',
    name: 'VerifyEmailView',
    component: VerifyEmailView
  },
  {
    path: '/complete-verification/:oobCode',
    name: 'CompleteVerificationView',
    component: CompleteVerificationView
  },
  {
    path: '/email-sent',
    name: 'LoginEmailSentView',
    component: LoginEmailSentView
  },
  {
    path: '/auth-callback',
    name: 'AuthCallbackView',
    component: AuthCallbackView
  },
  {
    path: '/share/boards/:id',
    name: 'BoardsPublicView',
    component: BoardsPublicView,
    meta: { product: 'library' }
  },
  {
    path: '/share/ads/:id',
    name: 'AdsPublicView',
    component: AdsPublicView,
    meta: { product: 'library' }
  },
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: DashboardView,
    meta: { requiresAuth: true, theme: 'blue' }
  },
  {
    path: '/briefs',
    name: 'BriefsView',
    component: BriefsView,
    meta: { requiresAuth: true, theme: 'green', product: 'briefs' }
  },
  {
    path: '/edit-briefs/:id',
    name: 'EditBriefView',
    component: EditBriefView,
    meta: { requiresAuth: true, theme: 'green', product: 'briefs' }
  },
  {
    path: '/share/briefs/:id',
    name: 'BriefPublicView',
    component: BriefPublicViewV2,
    meta: { theme: 'green', hideSidebar: true, product: 'briefs' }
  },
  {
    path: '/discovery',
    name: 'DiscoveryView',
    component: DiscoveryView,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery-brands',
    name: 'DiscoveryBrandsView',
    component: DiscoveryView,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery-experts',
    name: 'DiscoveryExpertsView',
    component: DiscoveryView,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery-experts/:id',
    name: 'DiscoveryExpertView',
    component: DiscoveryExpertView,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery/product-category/:category',
    name: 'DiscoveryProductCategoryView',
    component: DiscoveryAICategoryView,
    props: true,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery/creative-targeting/:category',
    name: 'DiscoveryCreativeTargetingView',
    component: DiscoveryAICategoryView,
    props: true,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/share/discovery-experts/:id',
    name: 'DiscoveryExpertPublicView',
    component: DiscoveryExpertPublicView,
    meta: { theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery-experts/:id/board/:boardId',
    name: 'DiscoveryExpertBoardPublicView',
    component: DiscoveryExpertView,
    meta: { theme: 'purple', product: 'discovery' }
  },
  {
    path: '/discovery-experts/:id/board/:boardId',
    name: 'DiscoveryExpertBoardView',
    component: DiscoveryExpertView,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/shared-discover/:id',
    name: 'SharedDiscover',
    component: AdsPublicViewDiscover,
    meta: { product: 'discovery' }
  },
  {
    path: '/library',
    name: 'LibraryView',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', liveUpdate: true, product: 'library' }
  },
  {
    // For tracking purposes
    path: '/welcome-49',
    name: 'Welcome49',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    // For tracking purposes
    path: '/welcome-99',
    name: 'Welcome99',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    path: '/library-brands',
    name: 'LibraryBrandsView',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    path: '/library-team',
    name: 'LibraryTeamView',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    path: '/library-mobile-saving',
    name: 'LibraryMobileSavingView',
    component: LibraryView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    path: '/spyder',
    name: 'SpyderBrandsView',
    component: SpyderBrandsView,
    meta: { requiresAuth: true, theme: 'red', product: 'spyder' }
  },
  {
    path: '/library-spyder/:id/:view?',
    name: 'SpyderView',
    component: SpyderView,
    meta: { requiresAuth: true, theme: 'red', product: 'spyder' }
  },
  {
    path: '/boards',
    name: 'BoardsView',
    component: BoardsView,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  {
    path: '/boards/:id',
    name: 'BoardsDetailsView',
    component: BoardsDetailsView,
    props: true,
    meta: { requiresAuth: true, theme: 'blue', liveUpdate: true, product: 'library' }
  },
  {
    path: '/discovery/brands/:id',
    name: 'DiscoveryBrandView',
    component: DiscoveryBrandView,
    props: true,
    meta: { requiresAuth: true, theme: 'purple', product: 'discovery' }
  },
  {
    path: '/brands/:id',
    name: 'BrandView',
    component: BrandView,
    props: true,
    meta: { requiresAuth: true, theme: 'blue', product: 'library' }
  },
  // {
  //   path: '/account',
  //   name: 'AccountView',
  //   component: AccountView,
  //   meta: { requiresAuth: true, theme: 'blue' }
  // },
  {
    path: '/perks',
    name: 'PerksView',
    component: PerksView,
    meta: { requiresAuth: true, theme: 'blue' }
  },
  // {
  //   path: '/manage-subscription',
  //   name: 'PaymentView',
  //   component: PaymentViewV2,
  //   meta: { requiresAuth: true, hideSidebar: true }
  // },
  {
    path: '/thank-you-solo-monthly',
    name: 'MonthlySoloThankYouRedirectView',
    component: ThankYouRedirectView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/thank-you-solo-annual',
    name: 'AnnualSoloThankYouRedirectView',
    component: ThankYouRedirectView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/thank-you-team-monthly',
    name: 'MonthlyTeamThankYouRedirectView',
    component: ThankYouRedirectView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/thank-you-team-annual',
    name: 'AnnualTeamThankYouRedirectView',
    component: ThankYouRedirectView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/success-purchase',
    name: 'PurchaseSuccessView',
    component: SuccessPurchaseView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/getting-started',
    name: 'UserOnboardView',
    component: UserOnboardView,
    meta: { requiresAuth: true, hideSidebar: true }
  },
  {
    path: '/auth-extension',
    name: 'ChromeExtensionAuthView',
    component: ChromeExtensionAuthView,
    meta: { requiresAuth: true }
  },
  {
    path: '/token-login/:token',
    name: 'TokenLoginView',
    component: TokenLoginView
  },
  {
    path: '/:utm',
    name: 'ExpertRedirect',
    component: ExpertRedirectView,
    meta: { hideSidebar: true }
  },
  {
    path: '*',
    redirect: { name: 'DiscoveryView' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Limited route names - compute to.meta.product and check against corresponding limits
const limitedRoutes = [
  'SpyderView',
  'LensDashboardView',
  'LensReport',
  'Lens'
]

// Route Guard
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['AuthModule/isUserLoggedIn']
  const isFreeTier = store.getters['AuthModule/isFreeTier']
  const team = store.getters['AuthModule/getTeam']
  const userFreeTrialDate = store.getters['AuthModule/getUserFreeTrialDate']
  const isInspoMode = store.getters['BriefsModule/getIsInspoMode']
  const activeLensId = store.getters['LensModule/getActiveLensId']
  const spyderLimit = store.getters['AuthModule/getSpyderLimit']
  const lensLimit = store.getters['AuthModule/getLensLimit']
  const initialLoad = store.getters['AuthModule/getInitialLoad']

  const currentUser = firebase.auth().currentUser
  const isEmailVerified = currentUser ? currentUser.emailVerified : false

  const needsUpgrade = isFreeTier && Date.now() > userFreeTrialDate + 6.048e8

  store.commit('RouterModule/SET_LAST_ROUTE', from.name)
  store.commit('RouterModule/SET_CURRENT_ROUTE', to.name)
  store.commit('RouterModule/SET_CURRENT_PARAMS', to.params)
  store.commit('AdvertisementsModule/SET_NEW_ADS', [])

  if (to.meta.betaLocked) {
    if (!store.getters['AuthModule/isBetaUser']) {
      next({ name: 'DiscoveryView' })
      return
    }
  }

  // Check the theme
  if (to.meta.theme) {
    if (isInspoMode) {
      store.commit('MiscModule/SET_THEME', 'green')
    } else {
      store.commit('MiscModule/SET_THEME', to.meta.theme)
    }
  }

  // Check if navigating to a different Lens, if so, set activeLensId and refetch metrics/presets
  if (to.meta.product === 'lens' && to.params?.lensId !== activeLensId) {
    const lensId = to.params?.lensId ?? null
    store.commit('LensModule/SET_ACTIVE_LENS_ID', lensId)
    store.dispatch('MetricsModule/fetchLensMetrics', lensId)
    store.dispatch('LensModule/fetchPresets', lensId)
    store.dispatch('LensModule/fetchTags', lensId)
  } else if (to.meta.product === 'lens') {
    // Otherwise, we're navigating to a general lens page without having metrics/presets yet, so fetch them
    if (_.isEmpty(store.getters['MetricsModule/getMetrics'])) {
      store.dispatch('MetricsModule/fetchLensMetrics')
    }
    if (_.isEmpty(store.getters['LensModule/getPresets'])) {
      store.dispatch('LensModule/fetchPresets')
    }
  }

  // store queries in cookies
  if (to.query.utm_source) {
    store.commit('MiscModule/SET_UTM_SOURCE', to.query.utm_source)
  }
  if (to.query.utm_medium) {
    store.commit('MiscModule/SET_UTM_MEDIUM', to.query.utm_medium)
  }
  if (to.query.utm_campaign) {
    store.commit('MiscModule/SET_UTM_CAMPAIGN', to.query.utm_campaign)
  }

  // Check if the user is logged in
  if (to.name !== 'LoginView' && !isAuthenticated && to.meta.requiresAuth) {
    next({ name: 'LoginView' })
    return
  }

  // Check if the user is email verified
  if (
    !['VerifyEmailView', 'CompleteVerificationView', 'LoginView', 'SignUpView'].includes(to.name) 
    && !isEmailVerified 
    && isAuthenticated 
    && to.meta.requiresAuth
  ) {
    if (from.query.authOob && from.name === 'LoginView') {
      next({ name: 'CompleteVerificationView', params: { oobCode: from.query.authOob } })
    } else {
      next({ name: 'VerifyEmailView' })
    }
    return
  }

  // Check if the user is onboarded
  const onboardingStatus = store.getters['AuthModule/getUserOnboardingStatus']
  const onboardingCompleted = onboardingStatus === 'FINISH'
  if (
    !['LoginView', 'SignUpView', 'UserOnboardView', 'VerifyEmailView', 'CompleteVerificationView'].includes(to.name) 
    && !onboardingCompleted 
    && isAuthenticated 
    && to.meta.requiresAuth
  ) {
    next({ name: 'UserOnboardView' })
    return
  }

  if (limitedRoutes.includes(to.name)) {
    const limit = to.meta.product === 'spyder' ? spyderLimit : to.meta.product === 'lens' ? lensLimit : null
    if (limit !== null && limit === 0) {
      const paywallRedirect = to.meta.product === 'spyder' ? 'SpyderBrandsView' : 'LensView'
      next({ name: paywallRedirect })
      return
    }
  }

  // Check if someone needs to upgrade
  if (!['ThankYouRedirectView', 'PaymentView', 'LibraryView', 'DiscoveryView'].includes(to.name) && isAuthenticated && to.meta.requiresAuth && needsUpgrade && !team) {
    next({ name: 'PaymentView' })
    return
  } else if (['LoginView', 'LoginEmailSentView'].includes(to.name) && isAuthenticated) {
    next({ name: 'DashboardView' })
    return
  }

  next()
})

export default router
